// src/Pages/Photography/Ukraine2022.jsx
import * as React from "react";
import { ThemeProvider, createTheme, Typography, Box, Grid, Button, Modal } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import pic1 from "./photography/immersion/immersion-i.jpg";
import pic2 from "./photography/immersion/immersion-ii.jpg";
import pic3 from "./photography/immersion/immersion-iii.jpg";
import pic4 from "./photography/immersion/immersion-0.jpg";

import Footer from "../Footer";

export default function Ukraine2022() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const [open, setOpen] = React.useState(false);
  const [modalSrc, setModalSrc] = React.useState(null);

  const handleOpen = (src) => {
    setModalSrc(src);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        minHeight="100vh"
        marginTop="5vh"
        maxWidth="100vw"
        pb="10vh"
      >
        {/* Title */}
        <Box sx={{ mb: "3vh" }}>
          <Typography
            variant="h1"
            component={require("react-router-dom").Link}
            to="/ph"
            sx={{
              textAlign: "center",
              color: "inherit",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            // immersion I–III
          </Typography>
        </Box>

        {/* Intro */}
        <Box sx={{ width: "80vw", maxWidth: 1200, mb: "3vh", textAlign: "center" }} />

        {/* Grid (T-shape): pic4 centered on its own row, same width as others */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ width: "80vw", maxWidth: 1200 }}
        >
          {/* Row 1: single centered item (same size as the others on desktop) */}
          <Grid container item xs={12} justifyContent="center">
            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => handleOpen(pic4)}
                sx={{ p: 0, minWidth: 0, lineHeight: 0, cursor: "zoom-in", width: "100%" }}
              >
                <img
                  src={pic4}
                  alt="Immersion 4"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Button>
            </Grid>
          </Grid>

          {/* Row 2: three items */}
          {[pic1, pic2, pic3].map((src, i) => (
            <Grid
              key={i}
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                onClick={() => handleOpen(src)}
                sx={{ p: 0, minWidth: 0, lineHeight: 0, cursor: "zoom-in", width: "100%" }}
              >
                <img
                  src={src}
                  alt={`Immersion ${i + 1}`}
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 0,
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "80vh",
            display: "flex",
          }}
        >
          {modalSrc && (
            <img
              src={modalSrc}
              alt="Preview"
              style={{ maxWidth: "90vw", maxHeight: "80vh", width: "auto", height: "auto" }}
            />
          )}
        </Box>
      </Modal>

      <Footer fixed />
    </ThemeProvider>
  );
}
